import React from 'react';
import { WixBaseUiEnvironmentProvider } from '@wix/wix-base-ui';
import { EditorType } from '@wix/platform-editor-sdk';
import { useExperiments } from '../..';
import { useSettingsEnvironment } from '../EnvironmentProvider';
import { getEditorType } from '../../helpers';
var specs = {
    editorXWithMadefor: 'specs.components.editorX.useMadefor',
    classicWithMadefor: 'specs.components.editorClassic.useMadefor',
    inputBorders: 'se_components_editorClassic_inputBorders',
};
var shouldUseMadefor = function (experiments, environment) {
    if (!experiments) {
        return false;
    }
    return environment.isEditorX
        ? experiments.enabled(specs.editorXWithMadefor)
        : experiments.enabled(specs.classicWithMadefor);
};
export var BaseUiEnvironmentProviderWrapper = function (_a) {
    var children = _a.children, experimentsConfig = _a.experimentsConfig;
    var useNoExperiments = function () { return null; };
    var useHook = experimentsConfig ? useExperiments : useNoExperiments;
    var experimentsContext = useHook();
    var environment = useSettingsEnvironment();
    var editorType = React.useMemo(getEditorType, []);
    return (React.createElement(WixBaseUiEnvironmentProvider, { madefor: shouldUseMadefor(experimentsContext === null || experimentsContext === void 0 ? void 0 : experimentsContext.experiments, environment), theme: environment.isEditorX ||
            environment.isWixStudio ||
            editorType === EditorType.Responsive
            ? 'responsive'
            : 'facelift', inputBorders: experimentsContext === null || experimentsContext === void 0 ? void 0 : experimentsContext.experiments.enabled(specs.inputBorders), dataHook: "base-ui-provider" }, children));
};
//# sourceMappingURL=index.js.map